import React, { useEffect, useState } from "react";
import { Check, Loader2, X } from "lucide-react";
import { useDelayedUnmount } from "../../hooks/useDelayedUnmount";

const AssetRenameDialog = ({
  isOpen,
  assetLabel,
  currentName,
  saving,
  onClose,
  onConfirm,
}) => {
  const [name, setName] = useState("");
  const visibility = useDelayedUnmount(Boolean(isOpen), 160);

  useEffect(() => {
    if (isOpen) {
      setName(currentName || "");
    }
  }, [currentName, isOpen]);

  if (!visibility.mounted) return null;

  const cleanName = name.trim();

  return (
    <div
      className={`fixed inset-0 z-[1000] flex items-center justify-center p-4 ${visibility.exiting ? "ui-backdrop-exit" : "ui-backdrop-enter"}`}
      style={{ backgroundColor: "var(--overlay-medium)" }}
      onMouseDown={onClose}
    >
      <form
        className={`w-full max-w-sm rounded-2xl border p-4 shadow-2xl ${visibility.exiting ? "ui-modal-exit" : "ui-modal-enter"}`}
        style={{
          backgroundColor: "var(--color-bg-secondary)",
          borderColor: "var(--color-border-primary)",
          color: "var(--color-text-primary)",
        }}
        onMouseDown={(event) => event.stopPropagation()}
        onSubmit={(event) => {
          event.preventDefault();
          if (!cleanName || saving) return;
          onConfirm(cleanName);
        }}
      >
        <div className="mb-4 flex items-center justify-between">
          <div>
            <div className="text-sm font-semibold">{assetLabel}更名</div>
            <div className="mt-1 text-xs" style={{ color: "var(--color-text-muted)" }}>
              只修改显示名称，不改变资产 ID 和入库绑定。
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ui-pressable inline-flex h-8 w-8 items-center justify-center rounded-full"
            style={{ backgroundColor: "var(--color-bg-tertiary)", color: "var(--color-text-secondary)" }}
          >
            <X size={15} />
          </button>
        </div>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold" style={{ color: "var(--color-text-muted)" }}>
            新名称
          </span>
          <input
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
            className="h-10 w-full rounded-lg border px-3 text-sm outline-none"
            style={{
              backgroundColor: "var(--color-bg-primary)",
              borderColor: "var(--color-border-primary)",
              color: "var(--color-text-primary)",
            }}
            placeholder={`输入${assetLabel}名称`}
          />
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="ui-pressable h-9 rounded-full px-4 text-xs font-semibold disabled:opacity-50"
            style={{ backgroundColor: "var(--color-bg-tertiary)", color: "var(--color-text-secondary)" }}
          >
            取消
          </button>
          <button
            type="submit"
            disabled={!cleanName || saving}
            className="ui-pressable inline-flex h-9 items-center gap-2 rounded-full px-4 text-xs font-semibold disabled:opacity-50"
            style={{ backgroundColor: "var(--color-accent-primary)", color: "white" }}
          >
            {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />}
            保存
          </button>
        </div>
      </form>
    </div>
  );
};

export default AssetRenameDialog;
